// import { getCoursesData, searchCoursesData } from "@/Api/courses";
// import { AddCourseBtn } from "@/App/Courses/Add";
import { Main } from "@/components/Main";
import { TriangleAlert } from "lucide-react";

export const NotFound = () => {
  return (
    <Main>
      <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
        <h2 className="text-2xl font-bold flex gap-2 items-center">
          <TriangleAlert />
          Error 404: Not Found Page
        </h2>
      </div>
      <div className="flex flex-col gap-3"></div>
    </Main>
  );
};
